<template>
    <div class="popupContainer">
        <div class="InfoList">
            <div class="inputLabelTop">{{ $t('withdraw.taxIdType') }}</div>
            <div class="tabList">
                <div class="tab_card" v-for="item in TAB_TYPE_LIST" :key="item.id"
                    :class="activeTab.id == item.id ? 'active_tab' : ''" @click="selectTabType(item)">
                    {{ item.name }}
                </div>
            </div>

            <div class="input_container" v-if="activeTab.id == 1">
                <van-field v-model="cpfID" type="number"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.cpfId != null && withdrawStore.withdrawInfo.cpfId != ''"
                 :placeholder="$t('withdraw.cpfIdPlaceholder')">
                    <template #left-icon>
                        <div class="inputLabel">CPF ID</div>
                    </template>
                </van-field>
            </div>
            <div class="input_container" v-if="activeTab.id == 2">
                <van-field v-model="emailID"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.email != null && withdrawStore.withdrawInfo.email != ''"
                    :placeholder="$t('withdraw.emailPlaceholder')">
                    <template #left-icon>
                        <div class="inputLabel">Email ID</div>
                    </template>
                </van-field>
            </div>
            <div class="input_container" v-if="activeTab.id == 3">
                <van-field v-model="phoneID" type="number"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.phone != null && withdrawStore.withdrawInfo.phone != ''"
                     :placeholder="$t('withdraw.phonePlaceholder')">
                    <template #left-icon>
                        <div class="inputLabel">PHONE ID</div>
                    </template>
                </van-field>
            </div>
            <div class="input_container" v-if="activeTab.id == 4">
                <van-field v-model="evpID" 
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.evpId != null && withdrawStore.withdrawInfo.evpId != ''"
                    :placeholder="$t('withdraw.evpPlaceholder')">
                    <template #left-icon>
                        <div class="inputLabel">EVP</div>
                    </template>
                </van-field>
            </div>
            <div class="errorText" v-if="activeTab.id == 1 && showCPFIdError
                || activeTab.id == 2 && showEmaiIdError
                || activeTab.id == 3 && showPhoneIdError
                || activeTab.id == 4 && showEvpIdError">
                {{
                    t(activeTab.errorText) }}</div>

            <div class="input_container">
                <van-field v-model="userName"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.userName != null && withdrawStore.withdrawInfo.userName != ''"
                     :placeholder="$t('withdraw.userNamePlaceholder')">
                    <template #left-icon>
                        <div class="inputLabel">{{ $t('withdraw.name') }}</div>
                    </template>
                </van-field>
            </div>

            <div class="input_container">
                <van-field v-model="cpfNumber" type="number"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.cpf != null && withdrawStore.withdrawInfo.cpf != ''"
                     :placeholder="$t('withdraw.userNamePlaceholder')">
                    <template #left-icon>
                        <div class="inputLabel">CPF</div>
                    </template>
                </van-field>
            </div>
            <div v-if="showCPFNumError" class="errorText">{{ $t("withdraw.cpfErrorText") }}</div>

            <div class="input_container" v-if="dataSetTwo?.selectedChannel.name == 'uupay'">
                <van-field v-model="brazilID"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.brazilId != null && withdrawStore.withdrawInfo.brazilId != ''"
                    type="number"  :placeholder="$t('withdraw.brazilIdPlaceholder')">
                    <template #right-icon>
                        <div class="inputLabel">{{ $t("withdraw.brazilId") }}</div>
                    </template>
                </van-field>
            </div>
            <div class="input_container" v-if="withdrawStore.selectedChannel.name == 'winwinpay'">
                <van-field v-model="bank"
                    :disabled="dataSetTwo?.isDisabled && withdrawStore.withdrawInfo.bank != null && withdrawStore.withdrawInfo.bank != ''"
                    type="text"  :placeholder="$t('withdraw.bankPlaceholder')">
                    <template #left-icon>
                        <div class="inputLabel">{{ $t("withdraw.bankName") }}</div>
                    </template>
                </van-field>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, defineExpose, defineEmits, watch, defineProps, onMounted, computed } from 'vue'
import { useI18n } from 'vue-i18n';
import { nextTick } from 'vue'
import { TAB_TYPE_LIST, WithdrawPopupData } from '@/view/withdraw/supportScript';
import { useWithdrawStore } from '@/stores/withdraw';
const { t } = useI18n();


const props = defineProps<{
    dataSetTwo: WithdrawPopupData
}>()

const withdrawStore = useWithdrawStore()
const activeTab = ref(TAB_TYPE_LIST[0])
const cpfID = ref(props.dataSetTwo.cpfID)
const emailID = ref(props.dataSetTwo.emailID)
const phoneID = ref(props.dataSetTwo.phoneID)
const evpID = ref(props.dataSetTwo.evpID)
const userName = ref(props.dataSetTwo.userName)
const cpfNumber = ref(props.dataSetTwo.cpfNumber)
const brazilID = ref(props.dataSetTwo.brazilID)
const bank = ref(props.dataSetTwo.bank)
const showCPFIdError = ref(props.dataSetTwo.showCPFIdError)
const showEmaiIdError = ref(props.dataSetTwo.showEmaiIdError)
const showPhoneIdError = ref(props.dataSetTwo.showPhoneIdError)
const showEvpIdError = ref(props.dataSetTwo.showEvpIdError)
const showCPFNumError = ref(props.dataSetTwo.showCPFNumError)
const activeButton = ref(false)

const emits = defineEmits(['close', 'open', 'selectTabType', 'confirmWithdrawPopup', 'updateFormValues', 'changeValue', 'checkFieldsFill'])

const open = (amount: number, data: any) => {
    emits('open')
}
const close = () => {
    emits('close')
}

const selectTabType = (item: any) => {
    activeTab.value = item
    emits('selectTabType', item)
}

const confirmWithdraw = () => {
    emitFormValues()
    emits('confirmWithdrawPopup')
}

const emitFormValues = () => {
    emits('updateFormValues', {
        cpfID: cpfID.value,
        emailID: emailID.value,
        phoneID: phoneID.value,
        evpID: evpID.value,
        userName: userName.value,
        cpfNumber: cpfNumber.value,
        brazilID: brazilID.value,
        bank: bank.value,
        activeTab: props.dataSetTwo.activeTab,
    })
}

watch(() => props.dataSetTwo, (newVal) => {
    if (cpfID.value !== newVal.cpfID) cpfID.value = newVal.cpfID
    if (emailID.value !== newVal.emailID) emailID.value = newVal.emailID
    if (phoneID.value !== newVal.phoneID) phoneID.value = newVal.phoneID
    if (evpID.value !== newVal.evpID) evpID.value = newVal.evpID
    if (userName.value !== newVal.userName) userName.value = newVal.userName
    if (cpfNumber.value !== newVal.cpfNumber) cpfNumber.value = newVal.cpfNumber
    if (brazilID.value !== newVal.brazilID) brazilID.value = newVal.brazilID
    if (bank.value !== newVal.bank) bank.value = newVal.bank
}, { deep: true })


watch(cpfID, (val) => {
    if (val.length == 11) {
        showCPFIdError.value = false
    } else {
        showCPFIdError.value = true
    }
    let data = {
        type: 'cpfID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(emailID, (val) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (emailRegex.test(val)) {
        showEmaiIdError.value = false
    } else {
        showEmaiIdError.value = true
    }
    let data = {
        type: 'emailID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(phoneID, (val) => {
    if (val.length == 11) {
        showPhoneIdError.value = false
    } else {
        showPhoneIdError.value = true
    }
    let data = {
        type: 'phoneID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(evpID, (val) => {
    if (val.length > 0) {
        showEvpIdError.value = false
    } else {
        showEvpIdError.value = true
    }
    let data = {
        type: 'evpID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(cpfNumber, (val) => {
    if (val.length == 11 || val.length == 0) {
        showCPFNumError.value = false
    } else {
        showCPFNumError.value = true
    }
    let data = {
        type: 'cpfNumber',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(userName, (val) => {
    let data = {
        type: 'userName',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(brazilID, (val) => {
    let data = {
        type: 'brazilID',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})
watch(bank, (val) => {
    let data = {
        type: 'bank',
        value: val
    }
    emits('changeValue', data)
    checkFieldsFill()
})

watch(activeTab, () => {
  checkFieldsFill()
})

const checkFieldsFill = () => {
    const activeId = activeTab.value.id 
    if (activeId === 1) {
        activeButton.value = (cpfID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showCPFIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 2) {
        activeButton.value = (emailID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEmaiIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 3) {
        activeButton.value = (phoneID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showPhoneIdError.value &&
            !showCPFNumError.value
    } else if (activeId === 4) {
        activeButton.value = (evpID.value !== '') &&
            (userName.value !== '') &&
            (cpfNumber.value !== '') &&
            !showEvpIdError.value &&
            !showCPFNumError.value
    }
    emits('checkFieldsFill', activeButton.value)
}


defineExpose({
    open,
    close,
    confirmWithdraw,
})

</script>
<style scoped>
.popupContainer {
    background: #3e2e4b;
    background-size: cover;
    background-repeat: repeat;
    width: 100%;
    /* min-height: 90vh; */
    padding: 10px 0;
    overflow-y: auto;
    border-radius: 10px;
    margin-top: 10px;
}


.InfoList {
    padding: 10px 20px;
}

.inputLabelTop {
    color: #f1bae0;
    font-size: 13px;
}

.van-popup::-webkit-scrollbar {
    display: none;
}

.topAmount {
    border-bottom: solid 0.5px rgba(255, 255, 255, 0.25);
    margin-bottom: 15px;
}

.inputLabel {
    color: #ffffffd9;
    font-size: 14px;
    margin: 5px 0;
    padding-right: 5px;
    border-right: 2px solid #65436f;
    min-width: 50px;
}

.amountRow {
    padding: 15px 0;

}

.amount {
    font-size: 15px;
    color: #FFF;
    padding-left: 15px;
}

.left_icon {
    color: rgba(255, 255, 255, 0.65);
    font-size: 17px;
    font-weight: bold;
    padding-right: 10px;
}

.tabList {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 5px;
}

.tabList::-webkit-scrollbar {
    display: none;
}

.tab_card {
    border-radius: 10px;
    width: 70px;
    color: #8b6e8b;
    background-color: #291632;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin-right: 10px;
    font-size: 13px;
}

.active_tab {
    background: #fd8966;
    color: #fff;
    border-radius: 10px;
}

.input_container>>>.van-field {
    background: #2c1d31 !important;
    border: 1px solid #65436f;
    color: #ffffffd9;
    padding: 5px 10px !important;
    margin-top: 5px;
    border-radius: 8px;
    align-items: center;
}

.input_container ::v-deep(.van-field__control) {
    font-size: 15px !important;
    color: #fd66b1 !important;
    font-weight: bold;
}

.input_container ::v-deep(.van-field__control::placeholder) {
    color: #fd66b191 !important;
    font-size: 13px !important;
    font-weight: 100;
    display: flex;
    align-items: center;
}

:deep(.van-field__control:disabled) {
    color: #fd66b1 !important;
    -webkit-text-fill-color: #fd66b1 !important;
}

.btn_container {
    padding: 10px 10px;
}

.errorText {
    color: red;
    margin: 5px;
    font-size: 11px;
}
</style>